import { SimilarFilters } from '../types/filters';

export const getDefaultSimilarFilters = (): SimilarFilters => ({
    strong: true,
    common: true,
    weak: true,
});
